import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';
import {Ambassador} from '@/app/core/models/ambassador';

@Injectable({
	providedIn: 'root'
})
export class AmbassadorService {

	constructor(
		private readonly http: HttpClient
	) {}

	getAllAmbassadors(): Observable<Ambassador[]> {
		return this.http.get<Ambassador[]>(`${environment.backendUrl}/ambassador`);
	}

}
